"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = FilledIcon;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function FilledIcon({
  icon,
  width,
  height,
  title,
  color
}) {
  switch (icon) {
    default:
    case "bookmark":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Bookmark", /*#__PURE__*/_react.default.createElement("path", {
        d: "M21 27L14 22L7 27V11C7 10.4696 7.21071 9.96086 7.58579 9.58579C7.96086 9.21071 8.46957 9 9 9H19C19.5304 9 20.0391 9.21071 20.4142 9.58579C20.7893 9.96086 21 10.4696 21 11V27Z",
        fill: color || "#FEF9EF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M23 25L16 20L9 25V9C9 8.46957 9.21071 7.96086 9.58579 7.58579C9.96086 7.21071 10.4696 7 11 7H21C21.5304 7 22.0391 7.21071 22.4142 7.58579C22.7893 7.96086 23 8.46957 23 9V25Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "calendar":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Calendar", /*#__PURE__*/_react.default.createElement("path", {
        d: "M21 10H7C5.89543 10 5 10.8954 5 12V26C5 27.1046 5.89543 28 7 28H21C22.1046 28 23 27.1046 23 26V12C23 10.8954 22.1046 10 21 10Z",
        fill: color || "#FEFCF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M23 8H9C7.89543 8 7 8.89543 7 10V24C7 25.1046 7.89543 26 9 26H23C24.1046 26 25 25.1046 25 24V10C25 8.89543 24.1046 8 23 8Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M20 6V10",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12 6V10",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M7 14H25",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "check-circle":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Check Circle", /*#__PURE__*/_react.default.createElement("circle", {
        cx: "14",
        cy: "18",
        r: "10",
        fill: color || "#F5FCFF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M26 15.08V16C25.9988 18.1564 25.3005 20.2547 24.0093 21.9818C22.7182 23.709 20.9033 24.9725 18.8354 25.5839C16.7674 26.1953 14.5573 26.1219 12.5345 25.3746C10.5117 24.6273 8.78465 23.2461 7.61095 21.4371C6.43726 19.628 5.87978 17.4881 6.02167 15.3363C6.16355 13.1846 6.9972 11.1363 8.39827 9.49706C9.79935 7.85781 11.6928 6.71537 13.7962 6.24013C15.8996 5.7649 18.1003 5.98232 20.07 6.85999",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M26 8L16 18.01L13 15.01",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "check":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Check", /*#__PURE__*/_react.default.createElement("path", {
        d: "M14 29C20.0751 29 25 24.0751 25 18C25 11.9249 20.0751 7 14 7C7.92487 7 3 11.9249 3 18C3 24.0751 7.92487 29 14 29Z",
        fill: color || "#E8FAF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M25 9L14 20L9 15",
        stroke: "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "dollar":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Dollar", /*#__PURE__*/_react.default.createElement("path", {
        d: "M14 29C20.0751 29 25 24.0751 25 18C25 11.9249 20.0751 7 14 7C7.92487 7 3 11.9249 3 18C3 24.0751 7.92487 29 14 29Z",
        fill: color || "#E8FAF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17 4V26",
        stroke: "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M22 8H14.5C13.5717 8 12.6815 8.36875 12.0251 9.02513C11.3687 9.6815 11 10.5717 11 11.5C11 12.4283 11.3687 13.3185 12.0251 13.9749C12.6815 14.6313 13.5717 15 14.5 15H19.5C20.4283 15 21.3185 15.3687 21.9749 16.0251C22.6313 16.6815 23 17.5717 23 18.5C23 19.4283 22.6313 20.3185 21.9749 20.9749C21.3185 21.6313 20.4283 22 19.5 22H11",
        stroke: "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "file-arrow":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "File Arrow", /*#__PURE__*/_react.default.createElement("rect", {
        x: "6",
        y: "8",
        width: "16",
        height: "20",
        rx: "2",
        fill: color || "#E8FAF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M18.5 6H10.5C9.96957 6 9.46086 6.21071 9.08579 6.58579C8.71071 6.96086 8.5 7.46957 8.5 8V24C8.5 24.5304 8.71071 25.0391 9.08579 25.4142C9.46086 25.7893 9.96957 26 10.5 26H22.5C23.0304 26 23.5391 25.7893 23.9142 25.4142C24.2893 25.0391 24.5 24.5304 24.5 24V12L18.5 6Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M18.5 6V12H24.5",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M29.6768 17.1768C29.7744 17.0791 29.7744 16.9209 29.6768 16.8232L28.0858 15.2322C27.9882 15.1346 27.8299 15.1346 27.7322 15.2322C27.6346 15.3299 27.6346 15.4882 27.7322 15.5858L29.1464 17L27.7322 18.4142C27.6346 18.5118 27.6346 18.6701 27.7322 18.7678C27.8299 18.8654 27.9882 18.8654 28.0858 18.7678L29.6768 17.1768ZM12.5 16.75C12.3619 16.75 12.25 16.8619 12.25 17C12.25 17.1381 12.3619 17.25 12.5 17.25V16.75ZM29.5 16.75H12.5V17.25H29.5V16.75Z",
        fill: "#1A202C"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M20.5 21H12.5",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M14.5 13H13.5H12.5",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "file":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "File", /*#__PURE__*/_react.default.createElement("rect", {
        x: "6",
        y: "8",
        width: "16",
        height: "20",
        rx: "2",
        fill: color || "#FEFCF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M18 6H10C9.46957 6 8.96086 6.21071 8.58579 6.58579C8.21071 6.96086 8 7.46957 8 8V24C8 24.5304 8.21071 25.0391 8.58579 25.4142C8.96086 25.7893 9.46957 26 10 26H22C22.5304 26 23.0391 25.7893 23.4142 25.4142C23.7893 25.0391 24 24.5304 24 24V12L18 6Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M18 6V12H24",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M20 17H12",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M20 21H12",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M14 13H13H12",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "flag":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Flag", /*#__PURE__*/_react.default.createElement("path", {
        d: "M6 21C6 21 7 20 10 20C13 20 15 22 18 22C21 22 22 21 22 21V9C22 9 21 10 18 10C15 10 13 8 10 8C7 8 6 9 6 9V21Z",
        fill: color || "#FEFCF6",
        stroke: "#FEFCF6",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M6 28V21",
        stroke: "#FEFCF6",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8 19C8 19 9 18 12 18C15 18 17 20 20 20C23 20 24 19 24 19V7C24 7 23 8 20 8C17 8 15 6 12 6C9 6 8 7 8 7V19Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8 26V19",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "folder":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Folder", /*#__PURE__*/_react.default.createElement("path", {
        d: "M14 29C20.0751 29 25 24.0751 25 18C25 11.9249 20.0751 7 14 7C7.92487 7 3 11.9249 3 18C3 24.0751 7.92487 29 14 29Z",
        fill: color || "#F4EFFD"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M27 22C27 22.5304 26.7893 23.0391 26.4142 23.4142C26.0391 23.7893 25.5304 24 25 24H9C8.46957 24 7.96086 23.7893 7.58579 23.4142C7.21071 23.0391 7 22.5304 7 22V8C7 7.46957 7.21071 6.96086 7.58579 6.58579C7.96086 6.21071 8.46957 6 9 6H14L16 9H25C25.5304 9 26.0391 9.21071 26.4142 9.58579C26.7893 9.96086 27 10.4696 27 11V22Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "globe":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Globe", /*#__PURE__*/_react.default.createElement("path", {
        d: "M14 28C19.5228 28 24 23.5228 24 18C24 12.4772 19.5228 8 14 8C8.47715 8 4 12.4772 4 18C4 23.5228 8.47715 28 14 28Z",
        fill: color || "#F5FCFF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M6 16H26",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16 6C18.5013 8.73835 19.9228 12.292 20 16C19.9228 19.708 18.5013 23.2616 16 26C13.4987 23.2616 12.0772 19.708 12 16C12.0772 12.292 13.4987 8.73835 16 6V6Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "home":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Home", /*#__PURE__*/_react.default.createElement("path", {
        d: "M5 15L14 8L23 15V26C23 26.5304 22.7893 27.0391 22.4142 27.4142C22.0391 27.7893 21.5304 28 21 28H7C6.46957 28 5.96086 27.7893 5.58579 27.4142C5.21071 27.0391 5 26.5304 5 26V15Z",
        fill: color || "#FEFCF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M7 13L16 6L25 13V24C25 24.5304 24.7893 25.0391 24.4142 25.4142C24.0391 25.7893 23.5304 26 23 26H9C8.46957 26 7.96086 25.7893 7.58579 25.4142C7.21071 25.0391 7 24.5304 7 24V13Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M13 26V16H19V26",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "info":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Info", /*#__PURE__*/_react.default.createElement("path", {
        d: "M14 28C19.5228 28 24 23.5228 24 18C24 12.4772 19.5228 8 14 8C8.47715 8 4 12.4772 4 18C4 23.5228 8.47715 28 14 28Z",
        fill: color || "#E8FAF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16 20V16",
        stroke: "#1A202C",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16 12H16.01",
        stroke: "#1A202C",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "layers":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Layers", /*#__PURE__*/_react.default.createElement("path", {
        d: "M14 29C20.0751 29 25 24.0751 25 18C25 11.9249 20.0751 7 14 7C7.92487 7 3 11.9249 3 18C3 24.0751 7.92487 29 14 29Z",
        fill: color || "#E8FAF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17 5.00006L6.99997 10.0001L17 15.0001L27 10.0001L17 5.00006Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M6.99997 20.0001L17 25.0001L27 20.0001",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M6.99997 15L17 20L27 15",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "light-bulb":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Light Bulb", /*#__PURE__*/_react.default.createElement("circle", {
        cx: "14.1923",
        cy: "17",
        r: "8",
        fill: color || "#FEFCF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16 18.7692V22.4615",
        stroke: "#1A202C",
        strokeWidth: "0.615385",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11.6974 24.3077H19.9079",
        stroke: "#1A202C",
        strokeWidth: "0.615385",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M13.0395 26.1539H18.171",
        stroke: "#1A202C",
        strokeWidth: "0.615385",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M4 15.6923H5.89474",
        stroke: "#1A202C",
        strokeWidth: "0.615385",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M6.52631 8.30768L7.86609 9.61311",
        stroke: "#1A202C",
        strokeWidth: "0.615385",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M26.1053 15.6923H28",
        stroke: "#1A202C",
        strokeWidth: "0.615385",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M24.2105 9.61316L25.5503 8.30773",
        stroke: "#1A202C",
        strokeWidth: "0.615385",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16 5.84613V3.99998",
        stroke: "#1A202C",
        strokeWidth: "0.615385",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12.61 22.4615C9.72184 21.2546 7.69232 18.4028 7.69232 15.0769C7.69232 10.6586 11.274 7.0769 15.6923 7.0769C20.1106 7.0769 23.6923 10.6586 23.6923 15.0769C23.6923 18.4028 21.6628 21.2546 18.7747 22.4615",
        stroke: "#1A202C",
        strokeWidth: "0.615385",
        strokeLinecap: "round"
      }));
    case "loading":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Loading", /*#__PURE__*/_react.default.createElement("path", {
        d: "M14 29C20.0751 29 25 24.0751 25 18C25 11.9249 20.0751 7 14 7C7.92487 7 3 11.9249 3 18C3 24.0751 7.92487 29 14 29Z",
        fill: color || "#F5FAFD"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17 5V9",
        stroke: "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17 21V25",
        stroke: "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M9.92999 7.92999L12.76 10.76",
        stroke: "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M21.24 19.24L24.07 22.07",
        stroke: "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M7 15H11",
        stroke: "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M23 15H27",
        stroke: "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M9.92999 22.07L12.76 19.24",
        stroke: "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M21.24 10.76L24.07 7.92999",
        stroke: "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "mail":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Mail", /*#__PURE__*/_react.default.createElement("path", {
        d: "M6 10H22C23.1 10 24 10.9 24 12V24C24 25.1 23.1 26 22 26H6C4.9 26 4 25.1 4 24V12C4 10.9 4.9 10 6 10Z",
        fill: color || "#F4EFFD"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8 8H24C25.1 8 26 8.9 26 10V22C26 23.1 25.1 24 24 24H8C6.9 24 6 23.1 6 22V10C6 8.9 6.9 8 8 8Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M26 10L16 17L6 10",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "map-pin":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Map Pin", /*#__PURE__*/_react.default.createElement("path", {
        d: "M23 16C23 23 14 29 14 29C14 29 5 23 5 16C5 13.6131 5.94821 11.3239 7.63604 9.63604C9.32387 7.94821 11.6131 7 14 7C16.3869 7 18.6761 7.94821 20.364 9.63604C22.0518 11.3239 23 13.6131 23 16Z",
        fill: color || "#FEF9EF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M25 14C25 21 16 27 16 27C16 27 7 21 7 14C7 11.6131 7.94821 9.32387 9.63604 7.63604C11.3239 5.94821 13.6131 5 16 5C18.3869 5 20.6761 5.94821 22.364 7.63604C24.0518 9.32387 25 11.6131 25 14Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16 17C17.6569 17 19 15.6569 19 14C19 12.3431 17.6569 11 16 11C14.3431 11 13 12.3431 13 14C13 15.6569 14.3431 17 16 17Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "message-send":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Send Message", /*#__PURE__*/_react.default.createElement("path", {
        d: "M24 8L17 28L13 19L4 15L24 8Z",
        fill: color || "#F5FCFF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M26 6L15 17",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M26 6L19 26L15 17L6 13L26 6Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "message":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Message", /*#__PURE__*/_react.default.createElement("path", {
        d: "M23 21C23 21.5304 22.7893 22.0391 22.4142 22.4142C22.0391 22.7893 21.5304 23 21 23H9L5 27V11C5 10.4696 5.21071 9.96086 5.58579 9.58579C5.96086 9.21071 6.46957 9 7 9H21C21.5304 9 22.0391 9.21071 22.4142 9.58579C22.7893 9.96086 23 10.4696 23 11V21Z",
        fill: color || "#FEFCF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M25 19C25 19.5304 24.7893 20.0391 24.4142 20.4142C24.0391 20.7893 23.5304 21 23 21H11L7 25V9C7 8.46957 7.21071 7.96086 7.58579 7.58579C7.96086 7.21071 8.46957 7 9 7H23C23.5304 7 24.0391 7.21071 24.4142 7.58579C24.7893 7.96086 25 8.46957 25 9V19Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "mobile":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Mobile", /*#__PURE__*/_react.default.createElement("path", {
        d: "M19 8H9C7.89543 8 7 8.89543 7 10V26C7 27.1046 7.89543 28 9 28H19C20.1046 28 21 27.1046 21 26V10C21 8.89543 20.1046 8 19 8Z",
        fill: color || "#E8FAF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M21 6H11C9.89543 6 9 6.89543 9 8V24C9 25.1046 9.89543 26 11 26H21C22.1046 26 23 25.1046 23 24V8C23 6.89543 22.1046 6 21 6Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16 22H16.01",
        stroke: "#1A202C",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "pause":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Pause", /*#__PURE__*/_react.default.createElement("path", {
        d: "M12 10H8V26H12V10Z",
        fill: color || "#FEF9EF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M20 10H16V26H20V10Z",
        fill: color || "#FEF9EF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M14 8H10V24H14V8Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M22 8H18V24H22V8Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "phone":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Phone", /*#__PURE__*/_react.default.createElement("path", {
        d: "M23.8881 22.9201V25.9201C23.8892 26.1986 23.8322 26.4743 23.7206 26.7294C23.6091 26.9846 23.4454 27.2137 23.2402 27.402C23.035 27.5902 22.7927 27.7336 22.5289 27.8228C22.265 27.912 21.9855 27.9452 21.7081 27.9201C18.631 27.5857 15.6751 26.5342 13.0781 24.8501C10.6619 23.3148 8.61345 21.2663 7.07812 18.8501C5.38809 16.2413 4.33636 13.2711 4.00812 10.1801C3.98313 9.90356 4.01599 9.62486 4.10462 9.36172C4.19324 9.09859 4.33569 8.85679 4.52288 8.65172C4.71008 8.44665 4.93792 8.28281 5.19191 8.17062C5.44589 8.05843 5.72046 8.00036 5.99812 8.0001H8.99812C9.48342 7.99532 9.95391 8.16718 10.3219 8.48363C10.6898 8.80008 10.9302 9.23954 10.9981 9.7201C11.1247 10.6802 11.3596 11.6228 11.6981 12.5301C11.8327 12.888 11.8618 13.277 11.782 13.651C11.7023 14.0249 11.517 14.3682 11.2481 14.6401L9.97812 15.9101C11.4017 18.4136 13.4746 20.4865 15.9781 21.9101L17.2481 20.6401C17.52 20.3712 17.8633 20.1859 18.2372 20.1062C18.6112 20.0264 19.0002 20.0556 19.3581 20.1901C20.2654 20.5286 21.2081 20.7635 22.1681 20.8901C22.6539 20.9586 23.0975 21.2033 23.4146 21.5776C23.7318 21.9519 23.9003 22.4297 23.8881 22.9201Z",
        fill: color || "#F5FCFF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M26 20.92V23.92C26.0011 24.1985 25.9441 24.4741 25.8325 24.7293C25.7209 24.9845 25.5573 25.2136 25.3521 25.4018C25.1468 25.5901 24.9046 25.7335 24.6407 25.8227C24.3769 25.9119 24.0974 25.945 23.82 25.92C20.7428 25.5856 17.787 24.5341 15.19 22.85C12.7738 21.3146 10.7253 19.2661 9.18999 16.85C7.49997 14.2412 6.44824 11.271 6.11999 8.17997C6.095 7.90344 6.12787 7.62474 6.21649 7.3616C6.30512 7.09846 6.44756 6.85666 6.63476 6.6516C6.82196 6.44653 7.0498 6.28268 7.30379 6.1705C7.55777 6.05831 7.83233 6.00024 8.10999 5.99997H11.11C11.5953 5.9952 12.0658 6.16705 12.4338 6.48351C12.8017 6.79996 13.0421 7.23942 13.11 7.71997C13.2366 8.68004 13.4714 9.6227 13.81 10.53C13.9445 10.8879 13.9737 11.2769 13.8939 11.6509C13.8141 12.0248 13.6289 12.3681 13.36 12.64L12.09 13.91C13.5135 16.4135 15.5864 18.4864 18.09 19.91L19.36 18.64C19.6319 18.3711 19.9751 18.1858 20.3491 18.1061C20.7231 18.0263 21.1121 18.0554 21.47 18.19C22.3773 18.5285 23.3199 18.7634 24.28 18.89C24.7658 18.9585 25.2094 19.2032 25.5265 19.5775C25.8437 19.9518 26.0122 20.4296 26 20.92Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "search":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Search", /*#__PURE__*/_react.default.createElement("path", {
        d: "M13 25C17.4183 25 21 21.4183 21 17C21 12.5817 17.4183 9 13 9C8.58172 9 5 12.5817 5 17C5 21.4183 8.58172 25 13 25Z",
        fill: color || "#FEF9EF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M23 27L18.65 22.65",
        stroke: "#FEF9EF",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15 23C19.4183 23 23 19.4183 23 15C23 10.5817 19.4183 7 15 7C10.5817 7 7 10.5817 7 15C7 19.4183 10.5817 23 15 23Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M25 25L20.65 20.65",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "star":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Star", /*#__PURE__*/_react.default.createElement("path", {
        d: "M14 8L17.09 14.26L24 15.27L19 20.14L20.18 27.02L14 23.77L7.82 27.02L9 20.14L4 15.27L10.91 14.26L14 8Z",
        fill: color || "#E8FAF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16 6L19.09 12.26L26 13.27L21 18.14L22.18 25.02L16 21.77L9.82 25.02L11 18.14L6 13.27L12.91 12.26L16 6Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "trend-up":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Trend Up", /*#__PURE__*/_react.default.createElement("path", {
        d: "M14 29C20.0751 29 25 24.0751 25 18C25 11.9249 20.0751 7 14 7C7.92487 7 3 11.9249 3 18C3 24.0751 7.92487 29 14 29Z",
        fill: color || "#F4EFFD"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M28 9L18.5 18.5L13.5 13.5L6 21",
        stroke: "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M22 9H28V15",
        stroke: "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "users":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Group", /*#__PURE__*/_react.default.createElement("path", {
        d: "M14 29C20.0751 29 25 24.0751 25 18C25 11.9249 20.0751 7 14 7C7.92487 7 3 11.9249 3 18C3 24.0751 7.92487 29 14 29Z",
        fill: color || "#FEF9EF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M22 24V22C22 20.9391 21.5786 19.9217 20.8284 19.1716C20.0783 18.4214 19.0609 18 18 18H10C8.93913 18 7.92172 18.4214 7.17157 19.1716C6.42143 19.9217 6 20.9391 6 22V24",
        stroke: "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M14 14C16.2091 14 18 12.2091 18 10C18 7.79086 16.2091 6 14 6C11.7909 6 10 7.79086 10 10C10 12.2091 11.7909 14 14 14Z",
        stroke: "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M28 24V22C27.9993 21.1137 27.7044 20.2528 27.1614 19.5523C26.6184 18.8519 25.8581 18.3516 25 18.13",
        stroke: "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M21 6.13C21.8604 6.35031 22.623 6.85071 23.1676 7.55232C23.7122 8.25392 24.0078 9.11683 24.0078 10.005C24.0078 10.8932 23.7122 11.7561 23.1676 12.4577C22.623 13.1593 21.8604 13.6597 21 13.88",
        stroke: "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "write":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Write", /*#__PURE__*/_react.default.createElement("path", {
        d: "M14 26.1213H23",
        stroke: "#FEF9EF",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M18.5 9.62132C18.8978 9.2235 19.4374 9 20 9C20.2786 9 20.5544 9.05487 20.8118 9.16148C21.0692 9.26808 21.303 9.42434 21.5 9.62132C21.697 9.8183 21.8532 10.0522 21.9598 10.3095C22.0665 10.5669 22.1213 10.8427 22.1213 11.1213C22.1213 11.3999 22.0665 11.6757 21.9598 11.9331C21.8532 12.1905 21.697 12.4243 21.5 12.6213L9 25.1213L5 26.1213L6 22.1213L18.5 9.62132Z",
        fill: color || "#FEF9EF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16 24H25",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M20.5 7.49998C20.8978 7.10216 21.4374 6.87866 22 6.87866C22.2786 6.87866 22.5544 6.93353 22.8118 7.04014C23.0692 7.14674 23.303 7.303 23.5 7.49998C23.697 7.69697 23.8532 7.93082 23.9598 8.18819C24.0665 8.44556 24.1213 8.72141 24.1213 8.99998C24.1213 9.27856 24.0665 9.55441 23.9598 9.81178C23.8532 10.0691 23.697 10.303 23.5 10.5L11 23L7 24L8 20L20.5 7.49998Z",
        stroke: "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "x-close":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Close", /*#__PURE__*/_react.default.createElement("path", {
        d: "M14 29C20.0751 29 25 24.0751 25 18C25 11.9249 20.0751 7 14 7C7.92487 7 3 11.9249 3 18C3 24.0751 7.92487 29 14 29Z",
        fill: color || "#F5FAFD"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M23 9L11 21",
        stroke: "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11 9L23 21",
        stroke: "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
  }
}
FilledIcon.propTypes = {
  /**
   * Sets color of icon
   */
  color: _propTypes.default.string,
  /**
   * Name of icon
   */
  icon: _propTypes.default.string.isRequired,
  /**
   * Sets width of icon
   */
  width: _propTypes.default.number,
  /**
   * Sets height of icon
   */
  height: _propTypes.default.number,
  /**
   * Sets title of icon for accessibility
   */
  title: _propTypes.default.string
};
FilledIcon.defaultProps = {
  height: 32,
  width: 32
};
FilledIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FilledIcon",
  "props": {
    "height": {
      "defaultValue": {
        "value": "32",
        "computed": false
      },
      "description": "Sets height of icon",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "width": {
      "defaultValue": {
        "value": "32",
        "computed": false
      },
      "description": "Sets width of icon",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "color": {
      "description": "Sets color of icon",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "icon": {
      "description": "Name of icon",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "title": {
      "description": "Sets title of icon for accessibility",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};